(function () {
  if (window.__IG_ID5_BUYBOX_LOADED__) return;
  window.__IG_ID5_BUYBOX_LOADED__ = true;

  var state = {
    ready: false,
    pageKey: "",
    info: null,
    syncTimer: null,
    priceTimer: null,
    io: null,
    stickyAtcHidden: true,
    stickyScrollBound: false,
    stickyLastY: 0,
    spHome: null,
    spResizeBound: false,
    payOrigin: null
  };

  var COPY = {
    members_get: {
      en: "Members get",
      nl: "Leden krijgen",
      de: "Mitglieder erhalten",
      fr: "Les membres reçoivent"
    },
    add_wishlist: {
      en: "Add to Wishlist",
      nl: "Toevoegen aan verlanglijstje",
      de: "Zur Wunschliste hinzufügen",
      fr: "Ajouter à la liste de souhaits"
    },
    color: { en: "Color", nl: "Kleur", de: "Farbe", fr: "Couleur" },
    size: { en: "Size", nl: "Maat", de: "Größe", fr: "Taille" },
    choose_size: {
      en: "Select a size",
      nl: "Maat kiezen",
      de: "Größe wählen",
      fr: "Choisir une taille"
    },
    sold_out: {
      en: "Sold out",
      nl: "Uitverkocht",
      de: "Ausverkauft",
      fr: "Épuisé"
    },
    notify_me: {
      en: "Notify me",
      nl: "Breng mij op de hoogte",
      de: "Benachrichtigen",
      fr: "Me prévenir"
    },
    add_to_cart: {
      en: "Add to cart",
      nl: "In winkelwagen",
      de: "In den Warenkorb",
      fr: "Ajouter au panier"
    },
    klarna_payments: {
      en: "3 payments of",
      nl: "3 betalingen van",
      de: "3 Zahlungen von",
      fr: "3 paiements de"
    },
    expected_delivery: {
      en: "Expected Delivery",
      nl: "Verwachte levering",
      de: "Lieferung voraussichtlich",
      fr: "Livraison prévue"
    }
  };

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function lang() {
    return (document.documentElement.lang || "en").slice(0, 2).toLowerCase();
  }

  function t(key) {
    var entry = COPY[key];
    if (!entry) return "";
    if (typeof entry === "string") return entry;
    return entry[lang()] || entry.en || "";
  }

  function isProductPage() {
    return !!(
      document.body &&
      (document.body.classList.contains("template-product") ||
        qs(".snippet-addto-cart"))
    );
  }

  function getSizeOption() {
    var marked = qs(".option-wrap.size, .option-wrap.ig5-size");
    if (marked) return marked;

    var wraps = qsa(".snippet-product-variant-selector .option-wrap");
    var i;
    for (i = 0; i < wraps.length; i++) {
      var wrap = wraps[i];
      if (wrap.classList.contains("d-none")) continue;
      var name = (wrap.getAttribute("data-name") || "").toLowerCase();
      var cls = (" " + wrap.className.toLowerCase() + " ").replace(/\s+/g, " ");
      if (
        name === "size" ||
        name === "maat" ||
        name === "größe" ||
        name === "groesse" ||
        name === "taille" ||
        cls.indexOf(" size ") > -1 ||
        cls.indexOf(" maat ") > -1 ||
        cls.indexOf(" groesse ") > -1 ||
        cls.indexOf(" grosse ") > -1 ||
        cls.indexOf(" taille ") > -1
      ) {
        wrap.classList.add("size", "ig5-size");
        return wrap;
      }
    }

    for (i = 0; i < wraps.length; i++) {
      var fallback = wraps[i];
      if (fallback.classList.contains("d-none")) continue;
      var fallbackName = (fallback.getAttribute("data-name") || "").toLowerCase();
      var fallbackCls = (" " + fallback.className.toLowerCase() + " ").replace(/\s+/g, " ");
      if (
        fallbackName === "color" ||
        fallbackName === "kleur" ||
        fallbackName === "farbe" ||
        fallbackName === "couleur" ||
        fallbackCls.indexOf(" color ") > -1 ||
        fallbackCls.indexOf(" kleur ") > -1 ||
        fallbackCls.indexOf(" farbe ") > -1 ||
        fallbackCls.indexOf(" couleur ") > -1
      ) {
        continue;
      }
      fallback.classList.add("size", "ig5-size");
      return fallback;
    }

    return null;
  }

  function getCheckedSize() {
    var opt = getSizeOption();
    return opt ? qs("input:checked", opt) : null;
  }

  function isSingleSize() {
    var opt = getSizeOption();
    if (!opt) return true;
    return qsa('input[type="radio"]', opt).length <= 1;
  }

  function hideSingleSizeSelector(info) {
    if (!isSingleSize()) return;
    var root = info || state.info || document;
    var opt = getSizeOption();
    if (opt) opt.classList.add("ig5-single-size-hide");
    var head = qs(".ig5-size-head", root);
    if (head) head.classList.add("ig5-single-size-hide");
    var variant = qs(".snippet-product-variant-selector", root);
    if (!variant) return;
    var visible = qsa(".option-wrap", variant).some(function (wrap) {
      return !wrap.classList.contains("d-none") && !wrap.classList.contains("ig5-single-size-hide");
    });
    if (!visible) variant.classList.add("ig5-single-size-hide");
  }

  function sizeSelected() {
    if (isSingleSize()) return true;
    return !!getCheckedSize();
  }

  function isSelectedSoldOut() {
    var checked = getCheckedSize();
    if (!checked) return false;
    var li = checked.closest("li");
    if (li && li.classList.contains("variant-unavailable")) return true;
    var cart = qs(".snippet-addto-cart .choose-cart");
    return !!(cart && cart.classList.contains("variant_sold-out"));
  }

  function getSelectedSizeLabel() {
    var checked = getCheckedSize();
    if (!checked) return "";
    var raw = checked.value || "";
    if (/^(XS|S|M|L|XL|XXL)$/i.test(raw)) return raw.toUpperCase();
    return checked.getAttribute("data-val") || raw;
  }

  function getSelectedQtyLeft() {
    var checked = getCheckedSize();
    if (!checked || !checked.nextElementSibling) return "";
    var qty = qs(".qty-left", checked.nextElementSibling);
    return qty ? qty.textContent.replace(/\s+/g, " ").trim() : "";
  }

  function getNotifyLabel() {
    return t("sold_out") + " - " + t("notify_me");
  }

  function setText(el, value) {
    if (el && el.textContent !== value) el.textContent = value;
  }

  function getPriceHtml() {
    var src =
      qs(".snippet-addto-cart .product-addcart .product-price") ||
      qs(".snippet-addto-cart .choose-selector .product-price") ||
      qs('[id^="price-btn-"]');
    return src ? src.innerHTML : "";
  }

  function applyPriceMedium(info) {
    var price = qs(".ig5-price-row .ig5-price", info || state.info);
    if (!price) return;
    price.classList.add("medium");
    price.style.setProperty("font-weight", "500", "important");
    price.style.setProperty("font-variation-settings", '"wght" 500', "important");
    price.style.setProperty("font-size", "14px", "important");
    price.style.setProperty("line-height", "14.4px", "important");
    qsa(".price-regular, .price-discounted", price).forEach(function (el) {
      el.classList.add("medium");
      el.style.setProperty("font-weight", "500", "important");
      el.style.setProperty("font-variation-settings", '"wght" 500', "important");
      el.style.setProperty("font-style", "normal", "important");
      el.style.setProperty("font-size", "14px", "important");
      el.style.setProperty("line-height", "14.4px", "important");
    });
  }

  function getAtcLabel() {
    var el =
      qs(".snippet-addto-cart .product-addcart .product-add-text") ||
      qs(".snippet-addto-cart .choose-selector .product-add-text");
    return el ? el.textContent.trim() : t("add_to_cart");
  }

  function getFeaturedThumb() {
    var img =
      qs(".media-slider .swiper-slide-active img") ||
      qs(".media-slider img") ||
      qs(".product-media img");
    return img ? img.currentSrc || img.src : "";
  }

  function getFlcAmount() {
    var nodes = [
      qs(".become-member"),
      qs(".snippet-product-usp .flc-reward"),
      qs(".pdp-title .flc-reward")
    ];
    for (var i = 0; i < nodes.length; i++) {
      if (!nodes[i]) continue;
      var m = nodes[i].textContent.match(/(\d[\d\s.]*)\s*FLC/i);
      if (m) return m[1].replace(/\s+/g, "") + " FLC";
    }
    return "";
  }

  function colorFromTitle(title) {
    if (!title) return "";
    var parts = String(title).split(/\s*\|\s*/);
    if (parts.length < 2) return "";
    return parts[parts.length - 1].replace(/^\s+|\s+$/g, "");
  }

  function pdpScope(info) {
    return info || state.info || qs(".product-info .sticky-info") || qs(".product-info") || document;
  }

  function getColorLabel(fromLink) {
    if (fromLink) {
      var fromLinkTitle = colorFromTitle(fromLink.getAttribute("data-product-title") || "");
      if (fromLinkTitle) return fromLinkTitle;
      var linkColor = (fromLink.getAttribute("data-color") || "").trim();
      if (linkColor) return linkColor;
    }

    if (window.__IG5_PDP__) {
      if (window.__IG5_PDP__.color) return String(window.__IG5_PDP__.color).trim();
      var fromPdpTitle = colorFromTitle(window.__IG5_PDP__.title || "");
      if (fromPdpTitle) return fromPdpTitle;
    }

    var scope = pdpScope();
    var root = qs(".snippet-product-color-selector", scope);
    if (root) {
      var fromRootTitle = colorFromTitle(root.getAttribute("data-product-title") || "");
      if (fromRootTitle) return fromRootTitle;
      var dataColor = (root.getAttribute("data-color") || "").trim();
      if (dataColor) return dataColor;
    }

    var wish = qs(".pdp-title [data-product-title]", scope);
    if (wish) {
      var fromWish = colorFromTitle(wish.getAttribute("data-product-title") || "");
      if (fromWish) return fromWish;
    }

    var active = qs(".snippet-product-color-selector .active-color a", scope);
    if (active) {
      var fromActiveTitle = colorFromTitle(active.getAttribute("data-product-title") || "");
      if (fromActiveTitle) return fromActiveTitle;
      var fromActive = (active.getAttribute("data-color") || "").trim();
      if (fromActive) return fromActive;
    }

    return "";
  }

  function formatColorName(name) {
    return String(name || "").replace(/^\s+|\s+$/g, "");
  }

  function syncColorLabel(info, colorName) {
    var root = pdpScope(info);
    var label = qs(".ig5-color-label", root);
    if (!label) return;

    var name = colorName != null ? colorName : getColorLabel();
    label.innerHTML = "";
    var prefix = document.createElement("strong");
    prefix.textContent = t("color") + ":";
    label.appendChild(prefix);
    if (name) label.appendChild(document.createTextNode(" " + formatColorName(name)));
  }

  function wireColorLabelSync(info) {
    qsa(".snippet-product-color-selector .grid-color a", info).forEach(function (link) {
      if (link.dataset.ig5ColorBound === "1") return;
      link.dataset.ig5ColorBound = "1";
      link.addEventListener("click", function () {
        syncColorLabel(info, getColorLabel(link));
      });
    });
  }

  function forceOpenSizeList() {
    var opt = getSizeOption();
    if (!opt) return;
    var list = qs(".variant-dropdown-list", opt);
    if (list) {
      if (list.style.height !== "auto") list.style.height = "auto";
      if (list.style.overflow !== "visible") list.style.overflow = "visible";
    }
    opt.classList.add("active");
  }

  function formatSoldOutButton() {
    var label = getNotifyLabel();
    qsa(".snippet-addto-cart .sold-out-btn .product-add-text").forEach(function (el) {
      setText(el, label);
    });
  }

  function ensureMembersFlc(info) {
    var el = qs(".become-member", info);
    if (!el) return;

    if (el.dataset.ig5Members !== "1") {
      var amount = getFlcAmount();
      if (amount) {
        el.dataset.ig5Members = "1";
        setText(el, t("members_get") + " " + amount);
      }
    }

    var left = qs(".pdp-title .left-title", info);
    if (left && el.parentElement !== left) left.appendChild(el);
  }

  function formatKlarnaText(info) {
    var textEl =
      qs(".ig5-price-row .main-klarna .text", info) ||
      qs(".main-klarna .text", info) ||
      qs(".main-klarna .text");
    if (!textEl) return;

    var label = t("klarna_payments");
    if (!label) return;

    var priceEl = qs(".price", textEl);
    var prefix = label + (priceEl ? " " : "");
    var first = textEl.childNodes[0];
    if (
      textEl.dataset.ig5Klarna === "1" &&
      first &&
      first.nodeType === 3 &&
      first.textContent === prefix
    ) {
      return;
    }

    textEl.dataset.ig5Klarna = "1";
    Array.prototype.slice.call(textEl.childNodes).forEach(function (node) {
      if (node.nodeType === 3) textEl.removeChild(node);
    });

    var node = document.createTextNode(prefix);
    if (priceEl) textEl.insertBefore(node, priceEl);
    else textEl.appendChild(node);
  }

  function buildPriceRow(info) {
    if (qs(".ig5-price-row", info)) return;
    var nativePrice = qs('h5[id^="price-"]', info);
    var row = document.createElement("div");
    row.className = "ig5-price-row";
    var price = document.createElement("div");
    price.className = "ig5-price product-price medium";
    price.innerHTML = getPriceHtml();
    row.appendChild(price);

    var klarna = qs(".main-klarna", info);
    if (klarna) row.appendChild(klarna);

    if (nativePrice) {
      nativePrice.replaceWith(row);
      applyPriceMedium(info);
      formatKlarnaText(info);
      return;
    }

    var title = qs(".pdp-title", info);
    if (!title) return;
    title.insertAdjacentElement("afterend", row);
    applyPriceMedium(info);
    formatKlarnaText(info);
  }

  function syncPriceRow(info) {
    var price = qs(".ig5-price-row .ig5-price", info);
    if (!price) return;
    var html = getPriceHtml();
    if (html && price.innerHTML !== html) price.innerHTML = html;
    applyPriceMedium(info);
  }

  function buildColorHead(info) {
    var color = qs(".snippet-product-color-selector", info);
    if (!color || color.closest(".ig5-color-block")) return;

    var block = document.createElement("div");
    block.className = "ig5-color-block";

    var head = document.createElement("div");
    head.className = "ig5-color-head";

    var label = document.createElement("span");
    label.className = "ig5-color-label";
    head.appendChild(label);

    var wish = document.createElement("button");
    wish.type = "button";
    wish.className = "ig5-wishlist";
    wish.innerHTML =
      "<span>" +
      t("add_wishlist") +
      '</span><svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M19.67 5.47c-1.99-1.64-4.95-1.35-6.78.48L12 6.84l-.89-.89C9.29 4.13 6.32 3.83 4.33 5.47 2.05 7.35 1.93 10.74 3.97 12.78L11.64 20.45c.2.2.51.2.71 0l7.67-7.67c2.05-2.04 1.93-5.42-.35-7.31z" stroke="currentColor" stroke-width="1.4"/></svg>';
    wish.addEventListener("click", function (e) {
      e.preventDefault();
      var btn =
        qs(".pdp-title .th_wl_button, .pdp-title .th_prd_wl_btn button, .pdp-title .wc_wishlistBlock button", info) ||
        qs(".pdp-title .th_prd_wl_btn", info);
      if (btn) btn.click();
    });
    head.appendChild(wish);

    block.appendChild(head);
    color.parentNode.insertBefore(block, color);
    block.appendChild(color);
    syncColorLabel(info);
    wireColorLabelSync(info);

    var wishSource = qs(".pdp-title .pdp-wishlist", info);
    if (wishSource) wishSource.style.display = "none";
  }

  function buildSizeHead(info) {
    var variant = qs(".snippet-product-variant-selector", info);
    if (!variant || qs(".ig5-size-head", variant)) return;
    var head = document.createElement("div");
    head.className = "ig5-size-head";
    head.innerHTML =
      '<div class="ig5-size-left"><span class="ig5-size-current"></span><span class="ig5-qty-left"></span></div>';
    var guide = qs(".pdp-size-guide", variant);
    if (guide) head.appendChild(guide);
    variant.insertBefore(head, variant.firstChild);
  }

  function syncSizeHead(info) {
    var current = qs(".ig5-size-head .ig5-size-current", info);
    var qty = qs(".ig5-size-head .ig5-qty-left", info);
    if (!current) return;

    var selected = getSelectedSizeLabel();
    var soldOut = isSelectedSoldOut();
    current.innerHTML = "";
    var prefix = document.createElement("strong");
    prefix.textContent = t("size") + ":";
    current.appendChild(prefix);
    if (selected) current.appendChild(document.createTextNode(" " + selected));

    if (!qty) return;
    if (!selected) {
      setText(qty, "");
      qty.classList.remove("is-sold-out");
      return;
    }
    if (soldOut) {
      setText(qty, t("sold_out"));
      qty.classList.add("is-sold-out");
      return;
    }
    setText(qty, getSelectedQtyLeft());
    qty.classList.remove("is-sold-out");
  }

  function shortenSizeLabels() {
    qsa(".option-wrap.size .variant-dropdown-list label > span:first-child").forEach(function (span) {
      var input = span.parentElement && span.parentElement.previousElementSibling;
      if (!input) return;
      var raw = input.value || "";
      if (/^(XS|S|M|L|XL|XXL)$/i.test(raw)) setText(span, raw.toUpperCase());
    });
  }

  function uspKind(li) {
    var meta = qs(".pu-meta", li);
    if (!meta) return "";
    if (qs(".expected-date", meta)) return "shipping";
    if (qs("pickup-status, #PickupStatus", meta)) return "boutique";
    if (qs(".flc-reward", meta)) return "rewards";
    return "returns";
  }

  function orderUsps(info) {
    var usp = qs(".snippet-product-usp", info);
    if (!usp || usp.dataset.ig5UspsOrder === "1") return;
    var ul = qs("ul", usp);
    if (!ul) return;

    var items = {};
    qsa("li", ul).forEach(function (li) {
      var kind = uspKind(li);
      if (kind && !items[kind]) items[kind] = li;
    });

    var order = ["shipping", "returns", "rewards", "boutique"];
    var moved = false;
    order.forEach(function (key) {
      if (items[key]) {
        ul.appendChild(items[key]);
        moved = true;
      }
    });
    if (moved) usp.dataset.ig5UspsOrder = "1";
  }

  function labelBoutiqueUsp(info) {
    var meta =
      qs('.snippet-product-usp .pu-meta[data-val="boutique-pick-up"]', info) ||
      qs('.snippet-product-usp .pu-meta[data-val="boutique-pickup"]', info) ||
      qs(".snippet-product-usp .pu-meta:has(pickup-status)", info) ||
      qs(".snippet-product-usp .pu-meta:has(#PickupStatus)", info);
    if (!meta) return;
    var title = qs("h3", meta);
    if (title) setText(title, "Amsterdam Boutique pick-up");
    flattenPickupStatus(meta);
  }

  function flattenPickupStatus(root) {
    var status = qs("#PickupStatus, pickup-status", root || document);
    if (!status) return;
    qsa("br", status).forEach(function (br) {
      br.replaceWith(document.createTextNode(" "));
    });
  }

  function labelShippingUsp(info) {
    var meta =
      qs('.snippet-product-usp .pu-meta[data-val="expected-delivery"]', info) ||
      qs('.snippet-product-usp .pu-meta[data-val="fast-shipping"]', info) ||
      qs(".snippet-product-usp .pu-meta:has(.expected-date)", info);
    if (!meta) return;

    var title = qs("h3", meta);
    if (title) setText(title, t("expected_delivery"));

    var date = qs(".expected-date", meta);
    if (!date) return;

    var prefixRe = /^(arrives|arriveert|kommt an|arrive)\s+/i;

    function applyDate() {
      var raw = (date.textContent || "").trim();
      if (!raw) return;
      raw = raw.replace(prefixRe, "");
      var parts = raw.split(":");
      raw = parts[parts.length - 1].trim();
      if (!raw) return;
      setText(date, raw);
    }

    applyDate();
    if (meta.dataset.ig5ShippingLabel === "1") return;
    meta.dataset.ig5ShippingLabel = "1";
    if ("MutationObserver" in window) {
      var obs = new MutationObserver(function () {
        applyDate();
      });
      obs.observe(date, { characterData: true, childList: true, subtree: true });
    }
  }

  function getSocialProofBlock(info) {
    var sp = qs("#fu-sp, .fu-sp", info);
    if (!sp) return null;
    return sp.closest(".shopify-block") || sp.closest("[id^='shopify-block']") || sp.parentElement;
  }

  function getDescriptionAnchor(info) {
    var desc = qs(".pdp-desc", info);
    if (desc) {
      return (
        desc.closest(".snippet-simple-content-product") ||
        desc.closest(".rte") ||
        desc
      );
    }
    var rtes = qsa(".snippet-simple-content-product > .rte", info);
    return rtes[0] || null;
  }

  function placeSocialProof(info) {
    var block = getSocialProofBlock(info);
    if (!block || !block.parentNode) return;

    if (!state.spHome) {
      state.spHome = {
        parent: block.parentNode,
        next: block.nextElementSibling
      };
    }

    var mobile = window.matchMedia("(max-width: 991px)").matches;
    var anchor = getDescriptionAnchor(info);
    var spacer = state.spHome.next;

    if (mobile && anchor && anchor.parentNode === block.parentNode) {
      if (block.previousElementSibling !== anchor) {
        anchor.insertAdjacentElement("afterend", block);
      }
      if (spacer && spacer !== block && !qs(".fu-sp", spacer)) {
        spacer.classList.add("ig5-sp-spacer-hide");
      }
      return;
    }

    if (state.spHome.parent) {
      if (state.spHome.next && state.spHome.next.parentNode === state.spHome.parent) {
        state.spHome.parent.insertBefore(block, state.spHome.next);
      } else if (block.parentNode !== state.spHome.parent) {
        state.spHome.parent.insertBefore(block, state.spHome.parent.firstChild);
      }
    }
    if (spacer) spacer.classList.remove("ig5-sp-spacer-hide");
  }

  function hideEmptySpacers(info) {
    qsa(".rte", info).forEach(function (rte) {
      var child = rte.firstElementChild;
      if (!child || child.id === "fu-sp" || qs(".fu-sp", rte)) return;
      var style = child.getAttribute("style") || "";
      if (style.indexOf("height:24px") === -1 && style.indexOf("height: 24px") === -1) return;
      var wrap = rte.parentElement;
      if (wrap && wrap !== info) wrap.classList.add("ig5-sp-spacer-hide");
      else rte.classList.add("ig5-sp-spacer-hide");
    });
  }

  function bindSocialProofPlacement(info) {
    hideEmptySpacers(info);
    placeSocialProof(info);
    if (state.spResizeBound) return;
    state.spResizeBound = true;
    window.addEventListener(
      "resize",
      function () {
        if (!state.info) return;
        hideEmptySpacers(state.info);
        placeSocialProof(state.info);
      },
      { passive: true }
    );
  }

  function getVisibleAtcRow(info) {
    var atc =
      info && info.classList && info.classList.contains("snippet-addto-cart")
        ? info
        : qs(".snippet-addto-cart", info || state.info);
    if (!atc) return null;
    return (
      qs(".choose-cart:not(.hide-selectore-button)", atc) ||
      qs(".choose-selector:not(.hide-selectore-button)", atc) ||
      qs(".choose-cart", atc) ||
      qs(".choose-selector", atc)
    );
  }

  function findPayIn(root) {
    if (!root) return null;
    var accel =
      qs("shopify-accelerated-checkout", root) ||
      qs("shopify-accelerated-checkout-cart", root);
    if (accel) {
      var wrap =
        accel.closest(".espress-checkout-button-selector") ||
        accel.closest(".shopify-payment-button") ||
        accel.closest("[data-shopify='payment-button']");
      return wrap || accel;
    }
    return (
      qs(".espress-checkout-button-selector", root) ||
      qs(".shopify-payment-button", root) ||
      qs("[data-shopify='payment-button']", root) ||
      qs(".pdp-apple-btn", root) ||
      null
    );
  }

  function findPayNode() {
    var stickySlot = qs(".ig5-sticky .ig5-sticky__qty");
    if (stickySlot) {
      var inSticky = findPayIn(stickySlot);
      if (inSticky) return inSticky;
    }
    var row = getVisibleAtcRow();
    var inRow = findPayIn(row);
    if (inRow) return inRow;
    return findPayIn(qs(".snippet-addto-cart", state.info));
  }

  function payHome(node) {
    if (!node) return null;
    var atc = qs(".snippet-addto-cart", state.info);
    if (!atc) return null;
    var chooseSelector = qs(".choose-selector", atc);
    var chooseCart = qs(".choose-cart", atc);

    if (node.classList && node.classList.contains("espress-checkout-button-selector") && chooseSelector) {
      return { parent: chooseSelector, before: qs("a.button", chooseSelector) };
    }

    if (state.payOrigin && state.payOrigin.parent && state.payOrigin.parent.isConnected) {
      return state.payOrigin;
    }

    var row = getVisibleAtcRow(atc) || chooseCart || chooseSelector;
    if (!row) return null;
    if (row === chooseSelector) {
      return { parent: chooseSelector, before: qs("a.button", chooseSelector) };
    }
    return {
      parent: row,
      before: qs(".product-addcart", row) || qs(".sold-out-btn", row) || qs("a.button", row)
    };
  }

  function placePayButton() {
    var node = findPayNode();
    if (!node) return;

    var sticky = qs(".ig5-sticky");
    var stickySlot = sticky ? qs(".ig5-sticky__qty", sticky) : null;
    var stickyOn = !!(sticky && sticky.classList.contains("is-visible"));
    var soldOut = !!(sizeSelected() && isSelectedSoldOut());

    if (stickyOn && stickySlot && !soldOut) {
      if (node.parentElement !== stickySlot) {
        if (!state.payOrigin || !state.payOrigin.parent) {
          state.payOrigin = {
            parent: node.parentElement,
            before: node.nextElementSibling
          };
        }
        stickySlot.appendChild(node);
      }
      return;
    }

    var home = payHome(node);
    if (!home || !home.parent) return;
    if (node.parentElement !== home.parent || (home.before && node.nextElementSibling !== home.before)) {
      if (home.before && home.before.parentNode === home.parent) {
        home.parent.insertBefore(node, home.before);
      } else {
        home.parent.appendChild(node);
      }
    }
    state.payOrigin = null;
  }

  function ensureQty(info) {
    var atc = qs(".snippet-addto-cart", info);
    if (!atc) return;
    var form = qs("form", atc);
    if (!form) return;

    var qtyInput = qs('input[name="quantity"]', form);
    if (!qtyInput) {
      qtyInput = document.createElement("input");
      qtyInput.type = "hidden";
      qtyInput.name = "quantity";
      qtyInput.value = "1";
      form.appendChild(qtyInput);
    }

    qsa(".ig5-qty", atc).forEach(function (slot) {
      while (slot.firstChild) slot.parentNode.insertBefore(slot.firstChild, slot);
      slot.parentNode.removeChild(slot);
    });

    placePayButton();

    if (atc.dataset.ig5PayWatch === "1") return;
    atc.dataset.ig5PayWatch = "1";
    if ("MutationObserver" in window) {
      var payObserver = new MutationObserver(function () {
        placePayButton();
      });
      payObserver.observe(atc, { childList: true, subtree: true });
    }
  }

  function placeTextBar(info) {
    var root = info || state.info;
    if (!root) return;
    var bar = qs(".product-text-bar-block", root) || qs(".product-text-bar-block");
    var atc = qs(".snippet-addto-cart", root);
    if (!bar || !atc || !atc.parentNode) return;
    if (bar.nextElementSibling === atc) return;
    atc.parentNode.insertBefore(bar, atc);
  }

  function syncStickyPromo() {
    var sticky = qs(".ig5-sticky");
    if (!sticky) return;
    var promo = qs(".ig5-sticky__promo", sticky);
    if (!promo) return;

    var source =
      qs(".product-text-bar-block .product-text-bar", state.info) ||
      qs(".product-text-bar-block .product-text-bar") ||
      qs(".product-text-bar", state.info) ||
      qs(".product-text-bar");

    if (!source) {
      sticky.classList.remove("has-promo");
      if (promo.innerHTML) promo.innerHTML = "";
      return;
    }

    sticky.classList.add("has-promo");
    var html = source.innerHTML;
    if (promo.innerHTML !== html) promo.innerHTML = html;
  }

  function setSwatchImage(link, src) {
    if (!link || !src) return;
    link.style.background = "none";
    link.style.backgroundColor = "transparent";
    link.style.backgroundImage = 'url("' + src + '")';
    link.style.backgroundSize = "cover";
    link.style.backgroundPosition = "center";
    link.style.backgroundRepeat = "no-repeat";
    link.style.border = "0";
    link.style.outline = "none";
    link.style.borderRadius = "0";
    link.setAttribute("data-image-ready", "1");
  }

  function productJsonUrl(href) {
    try {
      var url = new URL(href, window.location.origin);
      var parts = url.pathname.split("/").filter(Boolean);
      var idx = parts.indexOf("products");
      if (idx === -1 || !parts[idx + 1]) return "";
      return "/products/" + parts[idx + 1].split("?")[0] + ".js";
    } catch (e) {
      return "";
    }
  }

  function enhanceColorThumbs(info) {
    var root = info || document;
    var links = qsa(".snippet-product-color-selector .grid-color a", root);
    if (!links.length) return;

    links.forEach(function (link) {
      link.style.border = "0";
      link.style.outline = "none";
      link.style.borderRadius = "0";
      if (link.getAttribute("data-image-ready") !== "1") {
        link.style.background = "none";
        link.style.backgroundColor = "transparent";
      }

      if (link.getAttribute("data-image-ready") === "1") return;

      var dataImage = link.getAttribute("data-image");
      if (dataImage) {
        setSwatchImage(link, dataImage);
        return;
      }

      if (link.closest(".active-color")) {
        var local = getFeaturedThumb();
        if (local) setSwatchImage(link, local);
      }

      var jsonUrl = productJsonUrl(link.getAttribute("href") || "");
      if (!jsonUrl) return;

      fetch(jsonUrl)
        .then(function (res) {
          if (!res.ok) throw new Error("swatch fetch failed");
          return res.json();
        })
        .then(function (product) {
          var src =
            (product && product.featured_image) ||
            (product && product.images && product.images[0]) ||
            "";
          if (typeof src === "object" && src && src.src) src = src.src;
          if (src) {
            if (src.indexOf("//") === 0) src = "https:" + src;
            link.setAttribute("data-image", src);
            setSwatchImage(link, src);
          }
        })
        .catch(function () {});
    });
  }

  function syncSticky() {
    var bar = qs(".ig5-sticky");
    if (!bar) return;

    var sized = sizeSelected();
    var soldOut = sized && isSelectedSoldOut();
    bar.classList.toggle("is-sized", sized && !soldOut);
    bar.classList.toggle("is-sold-out", !!soldOut);

    var label = qs(".ig5-sticky__label", bar);
    if (label) {
      if (!sized) setText(label, t("choose_size"));
      else if (soldOut) setText(label, getNotifyLabel());
      else setText(label, getAtcLabel());
    }

    var prices = qs(".ig5-sticky__prices", bar);
    if (prices) {
      if (sized && !soldOut) {
        var html = getPriceHtml();
        if (html && prices.innerHTML !== html) prices.innerHTML = html;
      } else if (prices.innerHTML) {
        prices.innerHTML = "";
      }
    }

    syncStickyPromo();
    placePayButton();
  }

  function updateStickyVisibility() {
    var bar = qs(".ig5-sticky");
    if (!bar) return;
    bar.classList.toggle("is-visible", !state.stickyAtcHidden);
    placePayButton();
  }

  function isAtcInView(atc) {
    if (!atc) return false;
    var rect = atc.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight || 0;
    return rect.top < vh && rect.bottom > 0;
  }

  function isAtcScrolledPast(atc) {
    if (!atc) return false;
    return atc.getBoundingClientRect().bottom <= 0;
  }

  function refreshStickyState(atc) {
    if (!atc) {
      state.stickyAtcHidden = true;
      return;
    }
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    var scrollingUp = y < state.stickyLastY;
    state.stickyLastY = y;

    if (isAtcScrolledPast(atc)) {
      state.stickyAtcHidden = false;
      return;
    }

    if (scrollingUp && isAtcInView(atc) && !isAtcFullyUsable(atc)) {
      state.stickyAtcHidden = false;
      return;
    }

    state.stickyAtcHidden = isAtcInView(atc);
  }

  function isAtcFullyUsable(atc) {
    if (!atc) return false;
    var rect = atc.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight || 0;
    return rect.top >= 0 && rect.bottom <= vh - 8;
  }

  function buildSticky(info) {
    if (qs(".ig5-sticky")) return;

    var bar = document.createElement("div");
    bar.className = "ig5-sticky";
    bar.innerHTML =
      '<div class="ig5-sticky__promo" aria-hidden="true"></div>' +
      '<div class="ig5-sticky__main">' +
      '<div class="ig5-sticky__qty"></div>' +
      '<button type="button" class="ig5-sticky__btn">' +
      '<span class="ig5-sticky__label"></span>' +
      '<span class="ig5-sticky__prices"></span>' +
      "</button>" +
      "</div>";
    document.body.appendChild(bar);

    var atc = qs(".snippet-addto-cart", info);
    state.stickyAtcHidden = true;
    state.stickyLastY = window.pageYOffset || document.documentElement.scrollTop || 0;

    if (atc && "IntersectionObserver" in window) {
      state.io = new IntersectionObserver(
        function () {
          refreshStickyState(atc);
          updateStickyVisibility();
        },
        { threshold: [0, 0.01, 0.25, 0.5, 0.75, 1] }
      );
      state.io.observe(atc);
    }

    if (!state.stickyScrollBound) {
      state.stickyScrollBound = true;
      window.addEventListener(
        "scroll",
        function () {
          refreshStickyState(atc);
          updateStickyVisibility();
        },
        { passive: true }
      );
      window.addEventListener("resize", function () {
        refreshStickyState(atc);
        updateStickyVisibility();
      });
    }
    refreshStickyState(atc);
    updateStickyVisibility();
    placePayButton();

    qs(".ig5-sticky__btn", bar).addEventListener("click", function (e) {
      e.preventDefault();
      if (!sizeSelected()) {
        var opt = getSizeOption();
        if (opt) {
          forceOpenSizeList();
          opt.scrollIntoView({ behavior: "smooth", block: "center" });
        }
        return;
      }
      if (isSelectedSoldOut()) {
        var notify =
          qs(".snippet-addto-cart .choose-cart:not(.hide-selectore-button) .sold-out-btn") ||
          qs(".snippet-addto-cart .sold-out-btn");
        if (notify) notify.click();
        return;
      }
      var btn =
        qs(".snippet-addto-cart .choose-cart:not(.hide-selectore-button) .product-addcart") ||
        qs(".snippet-addto-cart .product-addcart");
      if (btn) btn.click();
    });
  }

  function syncUi(info) {
    forceOpenSizeList();
    formatSoldOutButton();
    syncSizeHead(info || state.info);
    syncColorLabel(info || state.info);
    syncPriceRow(info || state.info);
    formatKlarnaText(info || state.info);
    placeTextBar(info || state.info);
    flattenPickupStatus(info || state.info);
    syncSticky();
  }

  function scheduleSync(delay) {
    if (state.syncTimer) clearTimeout(state.syncTimer);
    state.syncTimer = setTimeout(function () {
      state.syncTimer = null;
      if (!state.ready) return;
      syncUi(state.info);
    }, delay || 0);
  }

  function wireVariantSync(info) {
    var radios = qs("variant-radios", info);
    if (!radios || radios.dataset.ig5Bound === "1") return;
    radios.dataset.ig5Bound = "1";

    radios.addEventListener("change", function () {
      scheduleSync(40);
      if (state.priceTimer) clearTimeout(state.priceTimer);
      state.priceTimer = setTimeout(function () {
        state.priceTimer = null;
        if (!state.ready) return;
        syncPriceRow(info);
        syncSticky();
        formatSoldOutButton();
      }, 650);
    });
  }

  function syncChooseSelectorLabel(info) {
    qsa(".snippet-addto-cart .choose-selector > a.button .product-add-text", info).forEach(function (el) {
      setText(el, t("choose_size"));
    });

    qsa(".snippet-addto-cart .choose-selector > a.button", info).forEach(function (btn) {
      if (btn.dataset.ig5Bound === "1") return;
      btn.dataset.ig5Bound = "1";
      btn.addEventListener(
        "click",
        function (e) {
          e.preventDefault();
          e.stopPropagation();
          var opt = getSizeOption();
          if (opt) {
            forceOpenSizeList();
            opt.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        },
        true
      );
    });
  }

  function init() {
    try {
      if (!isProductPage()) return;

      var info = qs(".product-info .sticky-info") || qs(".product-info");
      if (!info || !qs(".snippet-addto-cart", info)) return;

      var pageKey = location.pathname;
      if (state.ready && state.pageKey === pageKey) {
        syncColorLabel(info);
        return;
      }

      state.ready = true;
      state.pageKey = pageKey;
      state.info = info;
      info.dataset.ig5Ready = "1";

      ensureMembersFlc(info);
      buildPriceRow(info);
      buildColorHead(info);
      getSizeOption();
      buildSizeHead(info);
      hideSingleSizeSelector(info);
      shortenSizeLabels();
      orderUsps(info);
      labelBoutiqueUsp(info);
      labelShippingUsp(info);
      bindSocialProofPlacement(info);
      ensureQty(info);
      enhanceColorThumbs(info);
      syncChooseSelectorLabel(info);
      placeTextBar(info);
      buildSticky(info);
      wireVariantSync(info);
      syncUi(info);
    } catch (err) {
      state.ready = false;
      state.pageKey = "";
      if (window.console && console.warn) console.warn("[ig-id5-buybox]", err);
    }
  }

  function boot() {
    init();
    syncColorLabel(state.info);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }
  window.addEventListener("load", boot, { once: true });
  document.addEventListener("shopify:section:load", boot);
})();
